import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'provider_accounts',
  })

  let provider = useDataValue({
    viewPath: props.viewPath,
    context: 'provider_account',
    path: 'provider',
  })

  let account_id = useDataValue({
    viewPath: props.viewPath,
    context: 'provider_account',
    path: 'id',
  })
  return function onClick() {
    submit({ type: 'change_default', provider, account_id })
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
